export default function Hero() {
  return (
    <section className="relative min-h-screen flex items-center overflow-hidden bg-gradient-to-br from-slate-50 to-orange-50">
      {/* Background Image - Right Side */}
      <div className="absolute right-0 top-0 bottom-0 w-full lg:w-3/5">
        <img 
          src="https://public.readdy.ai/ai/img_res/73a1fe6931ac324b90991d7044adfb96.jpg"
          alt="Professional moving services in Southern California"
          className="w-full h-full object-cover object-center"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-slate-50 via-slate-50/80 to-transparent lg:from-slate-50 lg:via-slate-50/60"></div>
      </div>

      {/* Content - Left Aligned Asymmetrical Layout */}
      <div className="relative z-10 w-full max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-32 lg:py-40">
        <div className="max-w-2xl">
          {/* Trust Badge - Unique Diagonal Design */}
          <div className="inline-flex items-center gap-3 bg-gradient-to-r from-orange-500 to-red-500 text-white rounded-2xl px-5 py-3 mb-8 shadow-lg transform -rotate-1 hover:rotate-0 transition-transform">
            <i className="ri-shield-star-line text-2xl"></i>
            <div className="text-left">
              <div className="font-bold text-sm">Licensed & Insured</div>
              <div className="text-xs opacity-90">20+ Years Serving SoCal</div>
            </div>
          </div>

          {/* Main Heading - Conversational Voice Search Optimized */}
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-slate-900 mb-6 leading-tight">
            Need Movers You Can Trust in{' '}
            <span className="text-transparent bg-clip-text bg-gradient-to-r from-orange-500 to-red-500">
              Southern California?
            </span>
          </h1>

          {/* Subheading - Conversational Tone */}
          <p className="text-lg sm:text-xl text-slate-700 mb-8 leading-relaxed">
            We're your local, family-owned moving company serving Irvine, Indio, Newport Beach, and all of Orange County. From packing to unpacking, we handle your move with care—like it's our own family's belongings.
          </p>

          {/* CTA Buttons - Stacked on Mobile, Different Layout */}
          <div className="flex flex-col sm:flex-row gap-4 mb-10">
            <a 
              href="tel:7606257767" 
              className="group bg-gradient-to-r from-orange-500 to-red-500 text-white px-8 py-4 rounded-2xl font-bold text-lg hover:shadow-2xl hover:scale-105 transition-all whitespace-nowrap flex items-center justify-center gap-3"
            >
              <i className="ri-phone-fill text-2xl group-hover:animate-pulse"></i>
              <div className="text-left">
                <div className="text-xs opacity-90">Call Now</div>
                <div>(760) 625-7767</div>
              </div>
            </a>
            <a 
              href="#quote-form" 
              className="bg-white text-slate-900 px-8 py-4 rounded-2xl font-bold text-lg hover:bg-slate-50 transition-all shadow-lg hover:shadow-xl hover:scale-105 whitespace-nowrap border-2 border-slate-200 flex items-center justify-center gap-2"
            >
              <i className="ri-file-text-line text-xl"></i>
              Get Free Estimate
            </a>
          </div>

          {/* Trust Indicators - Unique Card Design */}
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <div className="bg-white rounded-2xl p-4 shadow-md border border-slate-100 hover:shadow-lg transition-shadow">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-orange-100 to-red-100 rounded-xl">
                  <i className="ri-price-tag-3-line text-2xl text-orange-600"></i>
                </div>
                <div>
                  <div className="font-bold text-slate-900 text-sm">Free Quotes</div>
                  <div className="text-xs text-slate-600">No Hidden Fees</div>
                </div>
              </div>
            </div>

            <div className="bg-white rounded-2xl p-4 shadow-md border border-slate-100 hover:shadow-lg transition-shadow">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-orange-100 to-red-100 rounded-xl">
                  <i className="ri-star-smile-line text-2xl text-orange-600"></i>
                </div>
                <div>
                  <div className="font-bold text-slate-900 text-sm">5-Star Rated</div>
                  <div className="text-xs text-slate-600">Local Reviews</div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Scroll Indicator - Different Animation */}
      <div className="absolute bottom-8 left-8 flex items-center gap-3 text-slate-600 animate-pulse">
        <div className="text-sm font-medium">Scroll to explore</div>
        <i className="ri-arrow-down-circle-line text-2xl text-orange-500"></i>
      </div>
    </section>
  );
}